/** `public` is allowed only on `auth.login`; `loopback` only on `system.healthz`. */
export const ROUTE_AUTHS = ['session', 'public', 'loopback'];
/** What a smoke-scoped session may do. `ack-write` is allowed only on `health.ping`. */
export const SMOKE_MODES = ['read', 'deny', 'ack-write'];
/**
 * Treatment of reference (SRD) documents, amendments 2.1 section 4 "Route annotation":
 * - `deny`: a reference id anywhere in the request answers 403;
 * - `target-ok`: a reference id may be a target, never the owner;
 * - `read`: read-only, reference documents may be returned, nothing is written;
 * - `none`: the route takes no document id.
 */
export const REFERENCE_MODES = ['deny', 'target-ok', 'read', 'none'];
export const ROUTE_STATUSES = ['frozen', 'draft'];
export const RESPONSE_KINDS = ['json', 'empty', 'text', 'file', 'sse'];
/**
 * How a request carries its body (1.0b deliverable 8): `json` (the default), or `multipart`, a
 * form whose `upload.field` holds one file and whose other fields the route's `body` describes.
 */
export const REQUEST_KINDS = ['json', 'multipart'];
/**
 * The body limit of `docs.create` and `docs.putBody` (16 MiB): a document past the 20,000-word
 * nudge still saves (PLAN section 2, Long documents: nothing is blocked). Every other JSON route
 * keeps the server's 1 MB cap. The proxy in front of the app must pass a body of this size.
 */
export const LARGE_BODY_BYTES = 16_777_216;
/**
 * The work packages whose routes carry a `stage`: a route is implemented once that stage of its
 * owner has merged, not when the owner's first stage merges.
 */
export const STAGED_ROUTE_OWNERS = [
    '1.A',
    '1.B-1',
    '1.C',
    '1.D',
    '1.L-2',
    '1.W',
    // CS r4a: the import routes, stages s1 to s4 (DECISIONS 177 item c).
    '2.B-1',
    // CS r5a: the session routes of Phase 2b, stages s1 and s2 (deliverable 145).
    '2.C',
    // CS r5b: the bootstrap and undo routes, stage s1 (deliverable 164).
    '2.J',
    '2.L',
    // CS r6a: the sheet and Foundry import routes of Phase 2c, stages s1, s2b and s3 (deliverable 183).
    '2.I',
    // CS r6c: the card writes, stage s1 (deliverable 202).
    '2.M',
];
/**
 * A stage id exactly as the owner's brief and `testing/stages.json` write it: digits, then an
 * optional letter (`1`, `2`, `2b`), or since CS r4a (DECISIONS 177 item c) a lower-case `s`, digits
 * and an optional letter (`s1`, `s2b`). `implementedRoutes` compares the two exactly.
 */
export const STAGE_ID_PATTERN = /^s?[0-9]+[a-z]?$/;
/**
 * The success status of a route: 200, or 201 or 202 for a json route that says so, 204 for
 * `empty`.
 */
export function successStatus(route) {
    const response = route.response;
    if (response.kind === 'empty')
        return 204;
    if (response.kind === 'json')
        return response.status ?? 200;
    return 200;
}
//# sourceMappingURL=types.js.map